const isDev = process.env.REACT_APP_ISDEV === 'true';
const isLocal = process.env.REACT_APP_ISLOCAL === 'true';
export const isProd = !isLocal && !isDev;

//--- Base api url
export const BASE_URL =
  process.env.REACT_APP_BASE_URL ||
  (isLocal ? 'http://localhost:3001' : isDev ? 'https://bpay-dev.bkpi.co' : 'https://s.bookipay.com');

export const BASE_BOOKIPI_WEB_URL =
  process.env.BASE_BOOKIPI_WEB_URL ||
  (isLocal ? 'http://localhost:3000' : isDev ? 'https://ac-app.bkpi.co' : 'https://web.bookipi.com');

//--- For testing
// export const BASE_URL = 'https://bpay-dev1.bkpi.co';
// export const BASE_URL = 'http://localhost:3001';
// export const CSS_SIGNATURE = 'da69c539ec14a82b538e143cb6e4d0f6';

//--- Css signature
export const CSS_SIGNATURE =
  process.env.REACT_APP_CSS_SIGNATURE ||
  (isLocal ? 'da69c539ec14a82b538e143cb6e4d0f6' : '51709a088a74c3d0005aa87cff2ce485');

//--- Base api url gql
export const BASE_URL_GQL = `${BASE_URL}/gql`;

//--- Base api url gql
export const BASE_URL_AMAZON = `https://bookipay.s3.amazonaws.com`;

//--- Config header Authorization with not token
const USER_NAME_AUTH = '5fbf07a6ed54fe2955911cdd';
const PASSWORD_AUTH = '$very-secret-password';
export const BASIC_AUTH = 'Basic ' + btoa(USER_NAME_AUTH + ':' + PASSWORD_AUTH);

//--- Branch link
export const BRANCH_LINK = isProd ? 'https://s6qao.app.link/ejC1uKksJwb' : 'https://s6qao.test-app.link/5rNoHYziGwb';

export const AMPLITUDE_API_KEY = process.env.REACT_APP_AMPLITUDE_API_KEY || 'b03445245bd1413e87214f89217c5352';

//--- Config for grant type login
export const GRANT_TYPE = 'password';
// export const GRANT_TYPE = 'bookipiaccount';

//--- Config for paging
export const SettingsPageConfig = {
  pageIndex: 1,
  pageSize: 10
};

export const ABR_GUID = 'c24ac29e-6aeb-4076-86f4-8c64c1af1212';

//--- Config: analytics
export const amplitudeConfig = 'b2d4ea4e9934cdc68b9ab785d3f4571e';

//--- Config: Survicate
export const SUBSCRIPTION_CANCELLATION_SURVICATE_ID = isProd ? 'c2eda653dcaf5433' : '833a2e0acf85bf7e';
export const SUBSCRIPTION_CANCELLATION_SURVICATE_ID_AIWB = isProd ? '2965e27fd3c5b01f' : '4ddf9c3569ecbcd1';
export const SUBSCRIPTION_DOWNGRADE_SURVICATE_ID = isProd ? '1dc161f9d96356eb' : '4a4262432b4b036d';

//--- Config: Growthbook
export const GROWTHBOOK_API_KEY = isProd ? 'key_prod_38eb9313e12b6254' : 'sdk-Q3sGw8cYPZiVt4XQ';
export const GROWTHBOOK_API_HOST = 'https://cdn.growthbook.io';

//--- Config: Stripe
export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  (isDev ? 'pk_test_Vcq4jChaMXHRjgpeR5usXgn500K2PUO0j4' : 'pk_test_Vcq4jChaMXHRjgpeR5usXgn500K2PUO0j4');
export const STRIPE_INVOICE_BEE_KEY =
  process.env.REACT_APP_STRIPE_INVOICE_BEE_KEY || 'pk_live_clPoy2p40H3DPrl45hOlvFzD';
